import { ApplicationFormEntryTask } from "./ApplicationFormEntryTask";

export const ApplicationFormFieldEntryTask = ApplicationFormEntryTask;
